import MatterDetail from './MatterDetail';

export default MatterDetail;
